// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pane_container[data-v-8ddda422] {\n  background: #fff;\n  padding: 10px;\n}\n.pane_container .box_description .box_span[data-v-8ddda422] {\n  font-size: 14px;\n  color: #1890ff;\n  border-bottom: 2px solid #1890ff;\n}\n.pane_container .parameterForm_css[data-v-8ddda422] {\n  padding: 0 5%;\n}\n.pane_container .parameterForm_css .el-form-item[data-v-8ddda422] {\n  width: 50%;\n  float: left;\n}", ""]);
// Exports
module.exports = exports;
